module.exports = __webpack_public_path__ + "static/img/14.f96784b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/14.jpg
// module id = 5Yi1
// module chunks = 1